import React from 'react';
import './DashboardSidebar.css';
import yhoLogo from '../../assets/yho-logo.png';

// Clean Enterprise Vector SVG Icons
const renderNavIcon = (id) => {
  const props = {
    viewBox: "0 0 24 24",
    width: "18",
    height: "18",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "nav-svg-icon"
  };

  switch (id) {
    case 'masterboard':
      return (
        <svg {...props}>
          <rect x="3" y="3" width="7" height="9" rx="1"></rect>
          <rect x="14" y="3" width="7" height="5" rx="1"></rect>
          <rect x="14" y="12" width="7" height="9" rx="1"></rect>
          <rect x="3" y="16" width="7" height="5" rx="1"></rect>
        </svg>
      );
    case 'traffic':
      return (
        <svg {...props}>
          <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
          <polyline points="17 6 23 6 23 12"></polyline>
        </svg>
      );
    case 'workshops':
      return (
        <svg {...props}>
          <circle cx="12" cy="12" r="10"></circle>
          <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon>
        </svg>
      );
    case 'registrations':
      return (
        <svg {...props}>
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
          <polyline points="10 9 9 9 8 9"></polyline>
        </svg>
      );
    case 'orders':
      return (
        <svg {...props}>
          <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <path d="M16 10a4 4 0 0 1-8 0"></path>
        </svg>
      );
    case 'coupons':
      return (
        <svg {...props}>
          <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
          <line x1="7" y1="7" x2="7.01" y2="7"></line>
        </svg>
      );
    case 'referrals':
      return (
        <svg {...props}>
          <circle cx="18" cy="5" r="3"></circle>
          <circle cx="6" cy="12" r="3"></circle>
          <circle cx="18" cy="19" r="3"></circle>
          <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
          <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
        </svg>
      );
    case 'inquiries':
      return (
        <svg {...props}>
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
          <polyline points="22 6 12 13 2 6"></polyline>
        </svg>
      );
    case 'internships':
      return (
        <svg {...props}>
          <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
          <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
        </svg>
      );
    case 'users':
      return (
        <svg {...props}>
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
      );
    case 'settings':
      return (
        <svg {...props}>
          <circle cx="12" cy="12" r="3"></circle>
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
        </svg>
      );
    default:
      return (
        <svg {...props}>
          <circle cx="12" cy="12" r="10"></circle>
        </svg>
      );
  }
};

const DashboardSidebar = ({ activeTab, setActiveTab, currentUser, onLogout }) => {
  let user = currentUser;
  if (!user) {
    try {
      const stored = localStorage.getItem('adminUser');
      if (stored) user = JSON.parse(stored);
    } catch (e) {}
  }

  const userName = user?.name || 'Admin User';
  const userEmail = user?.email || 'admin@yogahealers.org';
  const userRole = user?.role || 'Super Admin';
  const avatarInitial = userName ? userName.charAt(0).toUpperCase() : 'A';

  const menuSections = [
    {
      title: 'ANALYTICS',
      items: [
        { id: 'masterboard', label: 'Master Board', badge: 'Live' },
        { id: 'traffic', label: 'Website Traffic' },
      ]
    },
    {
      title: 'OPERATIONS',
      items: [
        { id: 'workshops', label: 'Workshops' },
        { id: 'registrations', label: 'Registrations' },
        { id: 'orders', label: 'Orders' },
      ]
    },
    {
      title: 'MARKETING & GROWTH',
      items: [
        { id: 'coupons', label: 'Coupons' },
        { id: 'referrals', label: 'Referrals' },
      ]
    },
    {
      title: 'COMMUNICATIONS',
      items: [
        { id: 'inquiries', label: 'Inquiries' },
        { id: 'internships', label: 'Internships' },
      ]
    },
    {
      title: 'SYSTEM ADMINISTRATION',
      items: [
        { id: 'users', label: 'User Directory' },
        { id: 'settings', label: 'Settings' },
      ]
    }
  ];

  return (
    <aside className="dashboard-sidebar">
      {/* Enterprise Brand Header */}
      <div className="sidebar-brand-wrapper">
        <div className="brand-logo-emblem">
          <img src={yhoLogo} alt="Yoga Healers" className="yho-brand-logo-img" />
        </div>
        <div className="brand-text-block">
          <div className="brand-title-row">
            <h2>Yoga Healers</h2>
            <span className="brand-version-badge">ENTERPRISE</span>
          </div>
          <span className="brand-subtext">Operations Console</span>
        </div>
      </div>

      {/* Navigation Sections */}
      <nav className="sidebar-nav-scroll">
        {menuSections.map((sec, idx) => (
          <div key={idx} className="nav-section-group">
            <span className="nav-section-heading">{sec.title}</span>
            <ul className="nav-items-list">
              {sec.items.map((item) => {
                const isActive = activeTab === item.id;
                return (
                  <li key={item.id}>
                    <button
                      className={`nav-menu-btn ${isActive ? 'active' : ''}`}
                      onClick={() => setActiveTab(item.id)}
                      type="button"
                    >
                      <span className="nav-item-icon">
                        {renderNavIcon(item.id)}
                      </span>
                      <span className="nav-item-text">{item.label}</span>
                      {item.badge && (
                        <span className="nav-live-pulse-badge">
                          <span className="pulse-dot"></span>
                          {item.badge}
                        </span>
                      )}
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </nav>

      {/* Sidebar Footer User Card */}
      <div className="sidebar-footer-card">
        <div className="sidebar-user-block">
          <div className="user-avatar-wrap">
            <div className="avatar-circle">{avatarInitial}</div>
            <span className="online-status-dot" title="Active"></span>
          </div>
          <div className="user-profile-meta">
            <div className="user-name-title" title={`${userName} (${userEmail})`}>{userName}</div>
            <div className="user-role-label" title={userEmail}>{userRole}</div>
          </div>
        </div>

        <button 
          className="sidebar-logout-action-btn" 
          onClick={onLogout} 
          title="Sign Out of Admin Console"
          type="button"
        >
          <svg className="logout-svg" viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
          <span>Sign Out</span>
        </button>
      </div>
    </aside>
  );
};

export default DashboardSidebar;
